import { queryOptions } from '@tanstack/vue-query'
import { getEmojiConfig } from '../api/get-emoji-config'

export const EMOJI_CONFIG_QUERY_KEY = ['emoji-config'] as const

export const emojiConfigQueryOptions = queryOptions({
  queryKey: EMOJI_CONFIG_QUERY_KEY,
  queryFn: () => getEmojiConfig(),
  staleTime: Infinity,
  gcTime: Infinity,
})
